import { combineReducers } from "redux";
import general from "./general";
import guestBook from "./guestBook";
export default combineReducers({ general,guestBook });
